var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('main',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.content.title))]),(_vm.content)?_c('Container',{attrs:{"content":_vm.content.container}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }